import { isNil } from "lodash";
import moment from "moment";

export const getDateWithTimeZone = (date?: Date | string | number, timeZone = "America/New_York") =>
	moment.tz(date, timeZone).startOf("day");

export const getRelativeYear = (yearsToAdd: number | null) => {
	return isNil(yearsToAdd) ? null : moment().add(yearsToAdd, "years").year();
};